import { tcf } from '@schibsted/sourcepoint';

import { frontendConfig } from '../../../src/core/system/config/frontend.server.js';

export const initSourcepoint = (): void => {
  tcf(window, document, navigator, frontendConfig.sourcepoint);
};
